import { render, staticRenderFns } from "./GuangzhouUnicom4.vue?vue&type=template&id=19a6dad8&scoped=true"
import script from "./GuangzhouUnicom4.vue?vue&type=script&lang=js"
export * from "./GuangzhouUnicom4.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouUnicom4.vue?vue&type=style&index=0&id=19a6dad8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a6dad8",
  null
  
)

export default component.exports